import styled from "styled-components";

import {
  DefaultParagraphMediumFactory,
  DefaultTitleLargeFactory,
} from "../../Habitacional/core/Typograph/Typograph.Style";

export const SectionBlockContainer = styled.section(({ theme }) => ({
  marginBottom: "0 !important",
  paddingTop: "40px",
  paddingBottom: "40px",
  borderBottom: `4px solid ${theme.color.line.medium}`,

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const SectionBlockContent = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: "64px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
    alignItems: "inherit",
  },

  ".image": {
    maxWidth: "253px",
    width: "100%",
    height: "253px",
  },
}));

export const Block = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
}));

export const BlockHeader = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}));

export const BlockTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const BlockDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphMediumFactory({ theme }),
}));

export const BlockList = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  flex: 1,

  span: {
    ...DefaultParagraphMediumFactory({ theme }),
  },
}));

export const BlockFooter = styled.footer(() => ({
  display: "flex",
  justifyContent: "center",
  marginTop: "auto",
}));
